export default function (status) {
  switch (status) {
    case 'Em análise':
      return 'label-warning';
    case 'Reprovado':
      return 'label-danger';
    case 'Aprovado':
      return 'label-success';
    default:
      return 'label-default';
  }
}
